import React from 'react';
import { Typography, Paper, Grid, Button } from '@mui/material';
import { SportsEsports, Search, Favorite } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Paper elevation={3} style={{ padding: '2rem', marginBottom: '2rem' }}>
        <Typography variant="h2" component="h1" gutterBottom align="center">
          Добро пожаловать в GameCatalogue!
        </Typography>
        <Typography variant="h5" component="p" align="center" color="textSecondary" paragraph>
          Ваш личный каталог игр. Ищите, находите и сохраняйте любимые игры!
        </Typography>
      </Paper>

      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Paper elevation={2} style={{ padding: '1.5rem', height: '100%' }}>
            <SportsEsports fontSize="large" color="primary" />
            <Typography variant="h5" gutterBottom>
              Большой каталог
            </Typography>
            <Typography variant="body1" paragraph>
              Более 30 популярных игр с подробным описанием, жанрами и рейтингами.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/games')}>
              Смотреть игры
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper elevation={2} style={{ padding: '1.5rem', height: '100%' }}>
            <Search fontSize="large" color="primary" />
            <Typography variant="h5" gutterBottom>
              Умный поиск
            </Typography>
            <Typography variant="body1" paragraph>
              Быстрый поиск по названию или описанию игры.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/search')}>
              Найти игру
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper elevation={2} style={{ padding: '1.5rem', height: '100%' }}>
            <Favorite fontSize="large" color="primary" />
            <Typography variant="h5" gutterBottom>
              Избранное
            </Typography>
            <Typography variant="body1" paragraph>
              Сохраняйте понравившиеся игры в избранное и возвращайтесь к ним позже.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/favorites')}>
              Мои избранные
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default Home;